import { IAppState } from '../../common/state';

export const getOffers = (state: IAppState) => state.results.offers;
